<template>
    <div>
        <slot name="preheader"></slot>

        <div v-if="!hideTitle" class="text-4xl font-medium font-access-legal tracking-tight mb-3 text-center text-brand-teal">
        <slot name="title">
            Connecting You to Your Lawyer
        </slot>
        </div>

        <template v-if="pacifier">
            <div class="flex items-center justify-between mt-8 text-brand-teal">
                <div class="flex flex-col space-y-2 items-center justify-start flex-1 text-sm">
                    <div class="flex flex-col items-center justify-center size-20 rounded-full border-2 border-brand-teal">
                        <i class="text-3xl fas fa-phone-alt" :class="[ leadIconClass ]"></i>
                    </div>
                    <span class="font-medium">You</span>
                </div>

                <div class="flex justify-center">
                    <i class="text-3xl text-brand-green fas fa-check" v-if="tenantState === 'answered'"></i>

                    <dots v-else></dots>
                </div>


                <div class="flex flex-col space-y-2 items-center justify-start flex-1 text-sm">
                    <div class="flex flex-col items-center justify-center size-20 rounded-full border-2 border-brand-teal">
                        <i class="text-3xl fas fa-phone" :class="[ tenantIconClass ]"></i>
                    </div>
                    <span class="font-medium">Lawyer</span>
                </div>
            </div>
        </template>

        <div class="flex items-center justify-center mt-2 text-center">
            <div>
                <div class="text-lg tracking-tight text-brand-teal">
                    <slot name="subtitle"></slot>
                </div>

                <!-- <div class="mt-2 font-bold text-md" v-if="hasTwilioNumber">
                    We&rsquo;re calling from {{ twilioNumber }}
                </div> -->
            </div>
        </div>

        <div class="flex justify-center mt-4">
            <button class="px-3 py-1 text-xs text-white bg-red-300 border-none rounded-full hover:bg-red-500"
                    type="submit"
                    @click="cancelCall"
                    v-if="leadState === 'ringing' || leadState === 'initiated'">
                Cancel call
            </button>
        </div>

        <slot name="extra"></slot>
    </div>
</template>

<script>
    export default {
        props: {
            leadState: {
                type: String
            },

            pacifier: {
                type: Boolean,
                default: true
            },

            hideTitle: {
                type: Boolean,
                default: false
            },

            tenantState: {
                type: String
            }
        },

        computed: {
            hasTwilioNumber() {
                return Boolean(process.env.MIX_TWILIO_NUMBER || false);
            },

            leadIconClass() {
                if (this.leadState === 'answered' || this.tenantState) {
                    return 'text-green-500';
                }

                if (this.leadState === 'ringing') {
                    return 'text-brand-teal-light';
                }

                return '';
            },

            tenantIconClass() {
                if (this.tenantState === 'answered') {
                    return 'text-green-500';
                }

                if (this.tenantState === 'ringing') {
                    return 'text-brand-teal-light';
                }

                return '';
            },

            twilioNumber() {
                if (this.hasTwilioNumber) {
                    return this.formatPhoneNumber(process.env.MIX_TWILIO_NUMBER);
                }
            },
        },

        methods: {
            cancelCall() {
                this.$event.$emit('cancel-call');
            },

            formatPhoneNumber(phone) {
                phone = phone.trim();

                let phoneTest = new RegExp(/^((\+1)|1)? ?\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})/);
                let results = phoneTest.exec(phone);

                if (results !== null && results.length > 5) {
                    return "(" + results[3] + ") " + results[4] + "-" + results[5];
                }

                return phone;
            }
        }
    }
</script>
